<template>
    <div class="flex items-center justify-center h-screen">
        <div class="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
    </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
  },
  data() {
    return {
      exampleData: ''
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    exampleMethod() {
      console.log('Example method');
    }
  },
  created() {
    //console.log('Loading created');
  },
  mounted() {
    //console.log('Loading mounted');
  }
};
</script>

<style scoped>
</style>